import { miloCore } from '@tencent/milo-core';
import { miloAlert } from '../AlertDialog';
export var commonFail = function commonFail(res) {
  var errMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var onFail = arguments.length > 2 ? arguments[2] : undefined;

  if (onFail && miloCore.isFunction(onFail)) {
    onFail({
      errMsg: errMsg,
      res: res
    });
  } else {
    miloAlert(errMsg);
  }
};